import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseIcon.svg";
import AButton from "../../../common/form-fields-mui/AButton";

const AddEventModal = ({
  isOpen,
  onClose,
  handleOpenLectureModal,
  handleOpenPTMModal = () => {},
  handleOpenCustomHolidayModal = () => {},
  handleOpenTestModal = () => {},
  isShowAddTest = false,
}) => {
  const eventButtons = [
    ...(isShowAddTest
      ? [{
          label: "Test",
          onClick: () => {
            handleOpenTestModal("Lecture");
            onClose();
          }
        }]
      : []),
    {
      label: "Lecture",
      onClick: () => handleOpenLectureModal("Lecture"),
    },
    {
      label: "Parent Connect - PTM",
      onClick: () => handleOpenPTMModal("PTM"),
    },
    {
      label: "Parent Connect - Orientation",
      onClick: () => handleOpenPTMModal("Orientation"),
    },
    {
      label: "Doubt class",
      onClick: () => handleOpenLectureModal("Doubt class"),
    },
    {
      label: "Extra class",
      onClick: () => handleOpenLectureModal("Extra class"),
    },
    {
      label: "Custom holiday",
      onClick: handleOpenCustomHolidayModal,
    },
    {
      label: "Demo class",
      onClick: ()=>handleOpenLectureModal("Demo class"),
    },
  ];

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={onClose}
      style={{ width: "510px" }}
    >
      <ModalBody>
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div className="heading-3 label-color">Add event</div>
          <CloseIcon onClick={onClose} />
        </div>
        <div className="semi-bold color-dark mb-3">
          Select an event you want to add
        </div>
        <div className="d-flex flex-wrap">
          {eventButtons.map((btn, index) => (
            <AButton
              key={index}
              variant="outline"
              className="btn-left-0 mr-3 mb-3"
              onClick={btn.onClick}
            >
              {btn.label}
            </AButton>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddEventModal;
